/* RESPONSIBLE TEAM: team-proactive-support */
export default function generateRequiredFeature(options) {
  return 'mobile_carousels';
}
